'use client';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';
import React from 'react';

type ClearAllTagVariant = 'red' | 'grey';
const ClearAllTag = ({
    tagClicked,
    variant = 'red',
}: {
    tagClicked: () => void;
    variant: ClearAllTagVariant;
}) => {
    const { t, IS_RTL } = useTranslation();

    const containerClasses = {
        grey: 'bg-gray-100 px-2.5 py-1 rounded-3xl inline-flex items-center justify-between cursor-pointer w-max m-1',
        red: `border border-error-200 outline-none text-error-500 py-2.5 rounded-lg bg-white cursor-pointer whitespace-nowrap ${
            IS_RTL ? 'px-4' : 'px-2.5'
        }`,
    };

    const textClasses = {
        grey: 'text-gray-700 w-max',
        red: 'text-error-500 w-max',
    };

    return (
        <div onClick={() => tagClicked()} className={containerClasses[variant]}>
            <Typography
                variant={'body2Medium'}
                style={
                    IS_RTL
                        ? { marginLeft: '4px', width: 'max-content' }
                        : { marginRight: '4px', width: 'max-content' }
                }
                className={textClasses[variant]}
            >
                {t('Clear')}
            </Typography>
        </div>
    );
};

export default ClearAllTag;
